import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStorageService } from "./../shared/services/session-storage.service";

import { SnackbarService } from "./../shared/services/snackbar.service";
import { VCStartService } from './virtual-consultation-start-page.service';
import { SharedService } from '../shared/services/shared.service';

import { isValidNumber } from 'libphonenumber-js';
import { contactViewPipe } from '../pipes/phone-view.pipe';
import { phoneFormatPipe } from '../pipes/phone-formatter.pipe';
import { config } from './../../../config/index';

@Component({
    template: require('./virtual-consultation-start-page.component.html'),
    styles: [require('./virtual-consultation-start-page.component.less')],
    preserveWhitespaces: true,
    providers: [SnackbarService, VCStartService, contactViewPipe, phoneFormatPipe]
})

export class VCStartPageComponent implements OnInit {

    constructor(
        private phoneFormatPipe: phoneFormatPipe,
        private contactViewPipe: contactViewPipe,
        private _mdlSnackbarService: SnackbarService,
        private _router: Router,
        private activatedRoute: ActivatedRoute,
        private _sessionStorageService: SessionStorageService,
        private _vcStartService: VCStartService,
        private _sharedService:SharedService
    ) {}

    isMobile: boolean = false;
    isAgreed: boolean;
    agreeTerms: any = [];
    vc_type: any;
    savedVcType: any = null;
    _patientFile: any = {};
    selectedOption: boolean = false;
    backgroundImage = require('../../assets/images/bg.png');
    phoneNumber: any;
    contactError:boolean;
    isDataRequired: boolean = false;
    buttonDisabled: boolean = true;
    phoneNumRegex: any =  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

    ngOnInit() {
        // this._sessionStorageService.clearItems();
        this.activatedRoute.params.subscribe(params => {
            let reqData = {
                token: params['token'],
            };
            this._vcStartService.vcDetailService(reqData)
                .subscribe((res: any) => {
                        this._sharedService.appColorSub.next(res.data.ortho_connect_color);
                        this._sessionStorageService.readItem('patientFile').then((data: any) => {
                            if (!data) {
                                this.initialiseData(res.data, params);
                            } else {
                                if (reqData.token !== data.token) {
                                    this._sessionStorageService.clearItems();
                                    this.initialiseData(res.data, params);
                                } else {
                                    this._patientFile = data;
                                    if(res.data.ortho_connect_color !==this._patientFile.ortho_connect_color) {
                                        this.changeBackgroundColor(res.data, params)
                                    }
                                    if(!this.isMobile)
                                        this._patientFile.countryCode = data.country.code;
                                        if (this._patientFile.countryCode !== 'US' && this._patientFile.countryCode !== 'CA') {
                                            this.phoneNumber = this.phoneFormatPipe.transform(this.phoneNumber, this._patientFile.countryCode);
                                        }
                                }
                            }
                            this.checkData();
                        })
                    },
                    (error: any) => {
                        this._sessionStorageService.clearItems();
                        if (error.error_code !== 323) {
                            this._router.navigate(['404']);
                        }
                    });
        });

        this.isMobile = this._sharedService.isMobileOrTabletDevice();
    }

    initialiseData(data: any, params: any) {
        this._patientFile = data;
        this._patientFile.token = params['token'];
        this._patientFile.switchToMobileBg = {
            backgroundColor: data.ortho_connect_color
        };
        this._patientFile.baseStyle = {
            background: 'url(' + this.backgroundImage + ') ' + data.widget_color
        };
        this._patientFile.baseColorStyle = data.widget_color;
        this._sessionStorageService.saveItem('patientFile', this._patientFile);

        if(!this.isMobile) {
            this._patientFile.countryCode = data.country.code;
            if (this._patientFile.countryCode !== 'US' && this._patientFile.countryCode !== 'CA') {
                this.phoneNumber = this.phoneFormatPipe.transform(this.phoneNumber, this._patientFile.countryCode);
            }
        }
    }

    changeBackgroundColor(data: any, params: any){
        this._patientFile.switchToMobileBg = {
            backgroundColor: data.ortho_connect_color
        };
        this._patientFile.baseStyle = {
            background: 'url(' + this.backgroundImage + ') ' + data.widget_color
        };
        this._patientFile.baseColorStyle = data.widget_color;
        this._sessionStorageService.saveItem('patientFile', this._patientFile);
    }

    checkData() {
        this._sessionStorageService.readItem('vcType').then((data: any) => {
            if(data) {
                this.savedVcType = data;
                this.vc_type = data;
            }
        });
        this._sessionStorageService.readItem('agreed').then((data: any) => {
            if(data) {
                    this.isAgreed = true;
                }else {
                    this.isAgreed = false;
            }
	    });
    }

    getStarted() {
        if (this.agreeTerms[0]) {
            this.isAgreed = true;
            this._sessionStorageService.saveItem('agreed', this.isAgreed);
        } else {
            this._mdlSnackbarService.showSnackbar('APPROVE_ALL_TERMS');
        }
    }

    goToVC() {
        if (this.vc_type) {
            if(this.savedVcType){
                if(this.vc_type === this.savedVcType){
                    this._router.navigate([this.vc_type]);
                } else {
                    delete this._patientFile.pageIndex;
                    this._sessionStorageService.saveItem('vcType', this.vc_type);
                    this._sessionStorageService.saveItem('patientFile', this._patientFile)
                    this._router.navigate([this.vc_type],{ replaceUrl: true });
                }
            } else {
                this._sessionStorageService.saveItem('vcType', this.vc_type);
                this._router.navigate([this.vc_type], { replaceUrl: true });
            }
        } else {
            this._mdlSnackbarService.showSnackbar('SELECT_APPOINTMENT_TYPE');
        }
    }

    openTerms(value: any){
        if (value === 1) {
            window.open(config.termsOfUseUrl)
        } else if (value === 2) {
            window.open(config.privacyPolicyUrl)
        }
    }

    phoneNumberInput() {
        if (this._patientFile.countryCode !== 'US' && this._patientFile.countryCode !== 'CA') {
            this.phoneNumber = this.phoneFormatPipe.transform(this.phoneNumber, this._patientFile.countryCode);
            this.phoneNumber = this.contactViewPipe.transform(this.phoneNumber);
        } else {
            this.phoneNumber = this.contactViewPipe.transformNational(this.phoneNumber, this._patientFile.countryCode);
        }
        this.validateContactNumber();
    }

    validateContactNumber() {
        this.contactError = false;
        if (this.phoneNumber && this._patientFile.countryCode) {
            if (this._patientFile.countryCode === 'US' || this._patientFile.countryCode === 'CA') {
                this.contactError = !this.phoneNumRegex.test(this.phoneNumber);
            } else {
                this.contactError = !isValidNumber(this.phoneNumber, this._patientFile.countryCode);
            }
        } else {
            this.contactError = true;
        }
        this.buttonDisabled = !this.contactError ? false : true;
        return this.contactError;
    }

    sendLink() {
        this.isDataRequired = true;
        if(!this.validateContactNumber()) {
            // convert phone format before saving
            let convertedPhoneNum = this.phoneNumber;
            if (convertedPhoneNum && (this._patientFile.countryCode === 'US' || this._patientFile.countryCode === 'CA')) {
                convertedPhoneNum = this.contactViewPipe.transform(convertedPhoneNum, this._patientFile.countryCode);
            }

            this._vcStartService.sendLinkService(convertedPhoneNum, this._patientFile.token).subscribe((res: any) => {
                convertedPhoneNum = this.phoneNumber = '';
                this._mdlSnackbarService.showSnackbar('SEND_LINK_SUCCESS', 'success');
            }, (error: any) => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG');
            });
            this.buttonDisabled = true;
        } else {
            this._mdlSnackbarService.showSnackbar('INVALID_NUMBER');
        }
    }
}